import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Features', href: '#features' },
    { label: 'Solutions', href: '#solutions' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Success Stories', href: '#success' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#" className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/2063d56d77349d69e524f0264c628611/bee8d5fb7f0cfa528bf76460a88c5217.png"
            alt="PRODIFY Logo"
            className="h-10 w-auto object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-300 hover:text-[#f97316] text-sm font-medium transition-colors duration-200 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#demo"
            className="px-5 py-2 text-sm font-semibold text-white border border-white/20 rounded-lg hover:border-[#f97316] hover:text-[#f97316] transition-all duration-200 whitespace-nowrap"
          >
            Book Demo
          </a>
          <a
            href="#pricing"
            className="px-5 py-2 text-sm font-semibold text-[#0a1628] bg-[#f97316] rounded-lg hover:bg-[#ea6c0a] transition-all duration-200 whitespace-nowrap"
          >
            Get Started
          </a>
        </div>

        <button
          className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#0a1628]/98 backdrop-blur-md px-6 pb-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-300 hover:text-[#f97316] text-sm font-medium transition-colors py-2 border-b border-white/10"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#demo"
            className="mt-2 px-5 py-3 text-sm font-semibold text-white text-center border border-white/20 rounded-lg hover:border-[#f97316] transition-all whitespace-nowrap"
          >
            Book Demo
          </a>
          <a
            href="#pricing"
            className="px-5 py-3 text-sm font-semibold text-[#0a1628] bg-[#f97316] rounded-lg text-center hover:bg-[#ea6c0a] transition-all whitespace-nowrap"
          >
            Get Started
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
